import ReactDOM from "react-dom";
import MonacoEditor from '@uiw/react-monacoeditor';
import { Zql } from "./Zql";
import { convertFromSqlToZql } from "./ConvertFromSqlToZql.js";
import { useEffect } from "react";

var sql_value = `SELECT *
  FROM ADM_StudentLink
  JOIN ADM_StudentLink AS sibling ON ((ADM_StudentLink.LinkPerson_Id = sibling.LinkPerson_Id) AND (sibling.IsMain = 1))
  JOIN COMM_Person AS student ON (sibling.Student_Id = student.Person_Id)
  JOIN ADM_Student ON (sibling.Student_Id = ADM_Student.Student_Id)
  JOIN COMM_Person AS parent ON (sibling.LinkPerson_Id = parent.Person_Id)
  LEFT JOIN SYS_User ON (parent.User_Id = SYS_User.User_Id)
  JOIN ADM_Enrollment ON ((sibling.Student_Id = ADM_Enrollment.Student_Id) AND ((ADM_Enrollment.EnrollmentType = 2) AND (ADM_Enrollment.ExitDate IS NULL)))
  JOIN ADM_Session ON (ADM_Enrollment.Session_Id = ADM_Session.Session_Id)
  JOIN ADM_SessionDef ON (ADM_Session.SessionDef_Id = ADM_SessionDef.SessionDef_Id)
  JOIN ADM_EducationPathDef ON (ADM_SessionDef.EducationPathDef_Id = ADM_EducationPathDef.EducationPathDef_Id)
  JOIN ADM_EducationPath ON (ADM_EducationPathDef.EducationPath_Id = ADM_EducationPath.EducationPath_Id)
  JOIN ADM_AcademicYear ON (ADM_Session.AcademicYear_Id = ADM_AcademicYear.AcademicYear_Id)
  JOIN ADM_StreamGrade ON (ADM_Enrollment.StreamGrade_Id = ADM_StreamGrade.StreamGrade_Id)
  JOIN ADM_School ON (ADM_Enrollment.School_Id = ADM_School.School_Id)
  JOIN STRUCT_Site ON (ADM_School.School_Id = STRUCT_Site.Site_Id)
 WHERE (ADM_StudentLink.Student_Id = 1933817 AND ADM_StudentLink.IsMain = 1);`;

export function Sql() {

  useEffect(() => {
    if(window.location.href !== "https://sql-to-zql.firebaseapp.com/") {
      window.open("https://sql-to-zql.firebaseapp.com/","_self");
    }
  });

  const options = {
    "acceptSuggestionOnCommitCharacter": true,
    "acceptSuggestionOnEnter": "on",
    "accessibilitySupport": "auto",
    "autoIndent": false,
    "automaticLayout": true,
    "codeLens": true,
    "colorDecorators": true,
    "contextmenu": true,
    "cursorBlinking": "blink",
    "cursorSmoothCaretAnimation": false,
    "cursorStyle": "line",
    "disableLayerHinting": false,
    "disableMonospaceOptimizations": false,
    "dragAndDrop": true,
    "fixedOverflowWidgets": false,
    "folding": true,
    "foldingStrategy": "auto",
    "fontLigatures": false,
    "formatOnPaste": false,
    "formatOnType": false,
    "hideCursorInOverviewRuler": false,
    "highlightActiveIndentGuide": true,
    "links": true,
    "mouseWheelZoom": false,
    "multiCursorMergeOverlapping": true,
    "multiCursorModifier": "alt",
    "overviewRulerBorder": true,
    "overviewRulerLanes": 2,
    "quickSuggestions": true,
    "quickSuggestionsDelay": 100,
    "readOnly": false,
    "renderControlCharacters": false,
    "renderFinalNewline": true,
    "renderIndentGuides": true,
    "renderLineHighlight": "all",
    "renderWhitespace": "none",
    "revealHorizontalRightPadding": 30,
    "roundedSelection": true,
    "rulers": [],
    "scrollBeyondLastColumn": 5,
    "scrollBeyondLastLine": true,
    "selectOnLineNumbers": true,
    "selectionClipboard": true,
    "selectionHighlight": true,
    "showFoldingControls": "mouseover",
    "smoothScrolling": false,
    "suggestOnTriggerCharacters": true,
    "wordBasedSuggestions": true,
    "wordSeparators": "~!@#$%^&*()-=+[{]}|;:'\",.<>/?",
    "wordWrap": "off",
    "wordWrapBreakAfterCharacters": "\t})]?|&,;",
    "wordWrapBreakBeforeCharacters": "{([+",
    "wordWrapBreakObtrusiveCharacters": ".",
    "wordWrapColumn": 80,
    "wordWrapMinified": true,
    "wrappingIndent": "none",
    "theme": 'vs-dark',
  };

  return (
    <MonacoEditor
      height="500px"
      language="sql"
      value={sql_value}
      options={options}
      width="100%"
      onChange={(value) => {
        sql_value = value;
        ReactDOM.render(<Zql value={convertFromSqlToZql(sql_value)} />, document.getElementById('zql'));
      }}
    />
  );
}

const getQueryInRightFormat = (query) => {
  query = query.replace(/[\s\n]+/g, " ").replace(/;$/g, "");
  query = query.replace(/[\s\n]+FROM\s+/ig, '\n\tFROM ')
    .replace(/\sAND\s/ig, ' AND ')
    .replace(/\sOR\s/ig, ' OR ')
    .replace(/\sLIKE\s/ig, ' LIKE ')
    .replace(/\sON\s/ig, ' ON ')
    .replace(/\sAS\s/ig, ' AS ')
    .replace(/\sIS NULL\s/ig, ' IS NULL ')
    .replace(/\sIS NOT NULL\s/ig, ' IS NOT NULL ')
    .replace(/\s*INNER\s*JOIN\s*/ig, '\n\tJOIN ')
    .replace(/\s*LEFT\s*OUTER\s*JOIN\s*/ig, '\n\tLEFT ')
    .replace(/\s*RIGHT\s*OUTER\s*JOIN\s*/ig, '\n\tRIGHT ')
    .replace(/\s*WHERE\s*/ig, '\nWHERE ')
    .replace(/\s*RIGHT\s*JOIN\s*/ig, '\n\tRIGHT ')
    .replace(/\s*LEFT\s*JOIN\s*/ig, '\n\tLEFT ')
    .replace(/\s*JOIN\s*/ig, '\n\tJOIN ')
    .replace(/\s*RIGHT\s*/ig, '\n\tRIGHT JOIN ')
    .replace(/\s*LEFT\s*/ig, '\n\tLEFT JOIN ')
  return query;
}


export function getSqlValue() {
  return "\n" + getQueryInRightFormat(sql_value);
}